import { useCallback, useMemo } from "react";
import ModalBasicLayout from "./ModalBasicLayout";
import FeatureAddonUnpaidPaywall from "../FeatureAddons/FeatureAddonUnpaidPaywall";
import { FEATURE_ADDON_KEYS } from "../../actions/featureAddons";
import TemplateProduce from "../../pages/Templates/TemplateProduce";
import { useTemplatesModals } from "../../contexts/templatesModalsContext";
import { useTranslationApp } from "../../lib/i18next";
import { TEMPLATES_PRODUCE_TITLE } from "../../i18n/keysTranslations";
import { normalizeStoredIDs } from "../../features/creativeTemplates/produce/produceRows";

const ModalTemplateProduce = ({
  modalOpen,
  onCloseModal,
  templateID = "",
  produceID = "",
  language = "",
  artboardIDs = [],
}) => {
  const { t } = useTranslationApp();
  const { openTemplatesList } = useTemplatesModals();
  const storedArtboardIDs = useMemo(
    () => normalizeStoredIDs({ value: artboardIDs }),
    [artboardIDs]
  );

  const onBackToList = useCallback(() => {
    onCloseModal();
    openTemplatesList();
  }, [onCloseModal, openTemplatesList]);

  return (
    <ModalBasicLayout
      modalOpen={modalOpen}
      onCloseModal={onCloseModal}
      fullScreen={true}
      maxWidth={false}
      fullWidth={true}
      hasTitle={false}
      ariaLabel={t(TEMPLATES_PRODUCE_TITLE)}
      sxContent={{
        p: 0,
        display: "flex",
        flexDirection: "column",
        width: "100%",
        height: "100vh",
        maxHeight: "100vh",
        overflow: "auto",
      }}
      sxPaper={{
        height: "100vh",
        maxHeight: "100vh",
      }}
    >
      <FeatureAddonUnpaidPaywall addonKey={FEATURE_ADDON_KEYS.TEMPLATES} />
      <TemplateProduce
        key={`${templateID}-${produceID}-${language}-${storedArtboardIDs.join(",")}`}
        initialTemplateID={templateID}
        initialProduceID={produceID}
        initialLanguage={language}
        initialArtboardIDs={storedArtboardIDs}
        onBackToList={onBackToList}
      />
    </ModalBasicLayout>
  );
};

export default ModalTemplateProduce;
